<template>
  <div class="page">
    <div class="card">
      <h1>后台登录</h1>
      <p class="sub">登录后可进行内容、会员与权限管理。</p>
      <p v-if="errorMsg" class="error">{{ errorMsg }}</p>
      <form class="login-form" autocomplete="off" @submit.prevent="submit">
        <label class="field">
          <span>账号</span>
          <input
            v-model.trim="username"
            name="admin-username"
            autocomplete="off"
            placeholder="请输入账号"
            @keyup.enter="submit"
          >
        </label>
        <label class="field">
          <span>密码</span>
          <input
            v-model="password"
            name="admin-password"
            type="password"
            autocomplete="new-password"
            placeholder="请输入密码"
            @keyup.enter="submit"
          >
        </label>
        <button class="btn btn-primary" type="submit">登录</button>
      </form>
    </div>
  </div>
</template>

<script>
import { adminLogin, setAdminToken } from '@/api'

export default {
  name: 'LoginView',
  data() {
    return {
      username: '',
      password: '',
      errorMsg: '',
    }
  },
  methods: {
    async submit() {
      try {
        this.errorMsg = ''
        if (!this.username || !this.password) throw new Error('请输入账号和密码')
        const data = await adminLogin({ username: this.username, password: this.password })
        setAdminToken(data.token || '')
        localStorage.setItem('admin.profile', JSON.stringify(data || {}))
        localStorage.setItem('admin.username', data.username || this.username)
        this.$router.replace('/dashboard')
      } catch (e) {
        this.errorMsg = e.message || '登录失败'
      }
    },
  },
}
</script>

<style scoped>
.page {
  height: 100%;
  min-height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f5ff 0%, #f7fbff 100%);
}
.card {
  width: 420px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e8eef8;
  padding: 24px;
  box-shadow: 0 16px 45px rgba(32, 63, 137, .12);
}
h1 { margin: 0 0 8px; font-size: 24px; color: #1d2939; }
.sub { color: #667085; margin: 0 0 14px; }
.field { display: flex; flex-direction: column; gap: 6px; margin-bottom: 10px; font-size: 13px; color: #344054; }
.field span { font-weight: 600; }
.login-form { margin: 0; }
input { border: 1px solid #d0d7e2; border-radius: 10px; padding: 10px 12px; }
.btn { width: 100%; border-radius: 10px; padding: 10px 14px; cursor: pointer; border: 1px solid transparent; font-size: 14px; }
.btn-primary { background: #2f6af6; color: #fff; }
.error { color: #d92d20; margin: 0 0 10px; }
</style>

